import { render, staticRenderFns } from "./satisraporu.vue?vue&type=template&id=5a41b13a&"
import script from "./satisraporu.vue?vue&type=script&lang=js&"
export * from "./satisraporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports